import { Button, Flex, EyeIcon, Text } from "@fluentui/react-northstar";
import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import moment from "moment";
import { useState } from "react";
import React from "react";

import { TeamsLoader } from "../../../_shared/components/TeamsLoader";
import { PagingControl } from "./components/PagingControl";
import { QuestionResultsGraph } from "./components/QuestionResultsGraph";
import { QuestionVoteField } from "./components/QuestionVoteField";

type SurveyCardBodyProps = {
  survey: SurveyDTO;
  hasLoadedResponses: boolean | undefined;
  surveyResponses: SurveyResponsesDTO;
  isSideBar: boolean | undefined;
  maxRespondents: number | undefined;
  onViewResults: ((survey: SurveyDTO, responses: SurveyResponsesDTO) => void) | undefined;
};

export const SurveyCardBody: React.FC<SurveyCardBodyProps> = ({
  survey,
  hasLoadedResponses,
  surveyResponses,
  isSideBar,
  maxRespondents,
  onViewResults,
}) => {
  const [page, setPage] = useState<number>(0);

  return (
    <Flex column gap="gap.small">
      {survey.state !== "pending" && (
        <TeamsLoader isLoading={!hasLoadedResponses}>
          <Flex column gap="gap.small">
            <PagingControl
              count={survey.questions.length}
              current={page}
              onChange={value => setPage(value)}
            />
            { survey.resultsVisibility === "private" && survey.role === 'own' && (
               <Flex styles={{ gap: "0.3rem" }} vAlign="center" hAlign="center">
               <EyeIcon size="medium" styles={{
                color: "#C50F1F",
                fontWeight: "bold",
              }} />
               <Text
                 content="Currently only viewable to you"
                 size='medium'
                 as="div"
                 styles={{
                  color: "#C50F1F",
                  fontWeight: "600",
                }}
               />
             </Flex>
            )}
            {survey.type !== "poll" && (
              <Text
                content={`${page + 1}) ${survey.questions[page].label}`}
                size="medium"
                weight="bold"
                as="div"
              />
            )}
            <QuestionResultsGraph
              question={survey.questions[page]}
              role={survey.role}
              responses={surveyResponses.responses}
              userResponse={surveyResponses.userResponse}
              canViewResults={surveyResponses.canViewResponses}
              anononymity={survey.anonymity}
              hideAvatars={isSideBar}
              maxRespondents={maxRespondents}
            />

            {onViewResults && surveyResponses.canViewResponses && (
              <Button
                secondary
                fluid
                content="Result Details"
                onClick={() => onViewResults(survey, surveyResponses)}
              />
            )}
          </Flex>
        </TeamsLoader>
      )}
      {survey.state === "pending" && (
        <Flex column gap="gap.small">
          <PagingControl
            count={survey.questions.length}
            current={page}
            onChange={value => setPage(value)}
          />

          {survey.type !== "poll" && (
            <Text
              content={`${page + 1}) ${survey.questions[page]?.label}`}
              size="medium"
              weight="bold"
              as="div"
            />
          )}
          <QuestionVoteField question={survey.questions[page]} />
        </Flex>
      )}
      {survey.state === "pending" && survey.deliverAt && (
        <Text
          align="center"
          color="orange"
          content={`Scheduled for ${moment(survey.deliverAt).format("LT")}`}
        />
      )}
    </Flex>
  );
};
